import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { Text } from '~/components/ui/text';
import { PATH } from '~/constants/route-path';

import { StyledLink, StyledTabs } from './styled';

const TABS_KEYS = {
  home: '/',
  faq: 'faq',
};

const tabs = [
  { label: 'buttons:home', key: TABS_KEYS.home, url: PATH.UNAUTH.MAIN },
  { label: 'buttons:faq', key: TABS_KEYS.faq, url: PATH.UNAUTH.FAQ },
];

export default function HeaderPublicTabs() {
  const { t } = useTranslation();

  const location = useLocation();

  return (
    <StyledTabs>
      {tabs.map(({ label, key, url }) => {
        return (
          <StyledLink key={key} $active={location.pathname === url} to={url}>
            <Text variant="buttonMedium" sx={{ color: 'inherit' }}>
              {t(label)}
            </Text>
          </StyledLink>
        );
      })}
    </StyledTabs>
  );
}
